import angular from 'angular';
import TermsPreviewDialogModule from '../terms-preview-dialog/terms-preview-dialog-module';
import TermsConfirmDialogModule from '../terms-confirm-dialog/terms-confirm-dialog-module';
import TermsTabComponent from './terms-tab-component';

export default angular
  .module('terms-tab', [
    TermsPreviewDialogModule.name,
    TermsConfirmDialogModule.name,
  ])
  .component('termsTab', new TermsTabComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/components/terms-tab/terms-tab-module.js